var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "calendar_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".calendar_svg__st0{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4h18c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1M2 10h20M2 16h20M8.5 2v4M15.5 2v4M8.5 10v12M15.5 10v12M22 6.5v13M2 6.5v13M7 22h10",
    className: "calendar_svg__st0"
  })));
};
export default SvgCalendar;